import A11yDialog from 'a11y-dialog'
import Blue from "~/core";

new Blue({
  name: "dialogContainer",
  selector: ".dialog__container",
  setup(dialogContainer) {
    const dialog = new A11yDialog(dialogContainer)
  }
});
